import { Component } from "@angular/core";
import { ViewController, NavParams } from "ionic-angular";

@Component({
  selector: 'page-regions',
  templateUrl: 'regions.html'
})

export class RegionsPage {
  
  private regions: any = [];
  public selected_region: string = '';
  
  constructor(public navParams: NavParams, public viewCtrl: ViewController) {
    
    let tmp_regions = this.navParams.data.regions;
    //console.log('data: ', this.navParams.data);
    tmp_regions.forEach((region: any) => {
       this.regions.push(region);
    });
    this.selected_region = this.navParams.data.selected
    //console.log('Regions: ', this.regions, this.selected_region);
  }

  change_region(item) {
    //console.log('Region: ', item);
    this.selected_region = item;
    this.close();
  }

  close() {
    //console.log('close: ', region);
    this.viewCtrl.dismiss({
      region: this.selected_region
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/regions/regions.ts